<template>
  <div class="form-container">
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" label-position="left">
      <el-form-item label="地址" prop="address">
        <el-input v-model="formData.address" placeholder="请输入地址" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="邮箱主体" prop="email1">
        <el-input v-model="formData.emailPrincipals" placeholder="请输入邮箱主体" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="邮箱1" prop="email1">
        <el-input v-model="formData.email1" placeholder="请输入邮箱1" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="邮箱2" prop="email2">
        <el-input v-model="formData.email2" placeholder="请输入邮箱2" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="联系电话主体" prop="phone1">
        <el-input v-model="formData.phonePrincipals" placeholder="请输入联系电话主体" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="联系电话1" prop="phone1">
        <el-input v-model="formData.phone1" placeholder="请输入联系电话1" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="联系电话2" prop="phone2">
        <el-input v-model="formData.phone2" placeholder="请输入联系电话2" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="联系微信" prop="wechat">
        <el-input v-model="formData.wechat" placeholder="请输入微信" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item label="联系QQ" prop="qq">
        <el-input v-model="formData.qq" placeholder="请输入QQ" :disabled="!isEditing"></el-input>
      </el-form-item>

      <el-form-item class="action-buttons">
        <el-button type="primary" @click="handleEdit" v-if="!isEditing">修改数据</el-button>
        <el-button type="primary" @click="handleSave" v-if="isEditing">保存</el-button>
        <el-button @click="handleReset" v-if="isEditing">重置</el-button>
        <el-button type="primary" @click="handleEdit" v-if="isEditing">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        address: '',
        emailPrincipals: '',
        email1: '',
        email2: '',
        phonePrincipals: '',
        phone1: '',
        phone2: '',
        wechat: '',
        qq: ''
      },
      originalData: {},
      isEditing: false,
      rules: {
        address: [
          {required: true, message: '请输入地址', trigger: 'blur'}
        ],
        email1: [
          {required: true, message: '请输入邮箱1', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change']}
        ],
        email2: [
          {type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change']}
        ],
        phone1: [
          {required: true, message: '请输入联系电话1', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        phone2: [
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        wechat: [
          {required: true, message: '请输入微信', trigger: 'blur'}
        ],
        qq: [
          {required: true, message: '请输入QQ', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{4,10}$/, message: '请输入正确的QQ号', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$api.getAppInfo().then((res) => {
        this.formData = {...res.data}
        this.originalData = {...res.data}
      })
    },
    handleEdit() {
      this.isEditing = !this.isEditing;
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('请填写正确的表单信息');
          return;
        }
        if (JSON.stringify(this.formData) === JSON.stringify(this.originalData)) {
          this.$message({
            message: '没有数据变化',
            type: 'error'
          });
          return
        }
        this.$confirm('您确定要修改吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.updateAppInfo(this.formData).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.isEditing = false;
              this.fetchData()
            }
          })
        })
      });
    },
    handleReset() {
      if (JSON.stringify(this.formData) === JSON.stringify(this.originalData)) {
        this.$message({
          message: '数据未变化，无需重置',
          type: 'warning'
        });
        return;
      }
    },
  }
}
</script>

<style scoped>
.action-buttons {
  margin-top: 30px;
  text-align: center;

  .el-button + .el-button {
    margin-left: 200px;
  }
}

.el-form-item {
  margin-bottom: 22px;
}
</style>